<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="170px">
      <el-form-item label="优惠券名称" prop="name">
        <el-input  v-model="form.name" placeholder="请输入优惠券名称"></el-input>
      </el-form-item>
      <el-form-item label="优惠券介绍" prop="introduce">
        <el-input
          v-model="form.introduce"
          placeholder="请输入优惠券介绍"
        ></el-input>
      </el-form-item>
      <el-form-item label="减免金额(元)" prop="reduceCost">
        <el-input
          v-model="form.reduceCost"
          :disabled="!!editorialJudgment&&editorialJudgmedis&&!perMission"
          placeholder="请输入减免金额"
        ></el-input>
      </el-form-item>
      <el-form-item label="起用金额(元)" prop="leastCost">
        <el-input
          v-model="form.leastCost"
          :disabled="!!editorialJudgment&&editorialJudgmedis&&!perMission"
          placeholder="请输入起用金额"
        ></el-input>
      </el-form-item>
      <el-form-item label="限领数量" prop="limitCount">
        <el-input
          v-model="form.limitCount"
          :disabled="!!editorialJudgment&&editorialJudgmedis&&!perMission"
          placeholder="请输入限领数量"
        ></el-input>
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker
          v-model="form.startTime"
          type="datetime"
          :disabled="!!editorialJudgment&&editorialJudgmedis&&!perMission"
          placeholder="选择开始时间"
          @change="dataSearch"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker
          v-model="form.endTime"
          :disabled="!!editorialJudgment&&editorialJudgmedis&&!perMission"
          type="datetime"
          placeholder="选择结束时间"
          @change="dataEnd"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="优惠券类型">
        <el-select
          class="filter-item"
          v-model="form.type"
          :disabled="!!editorialJudgment&&editorialJudgmedis&&!perMission"
          placeholder="请选择"
          @change="selectCustomized"
        >
          <el-option
            v-for="item in customized"
            :key="item.index"
            :label="item.name"
            :value="item.index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="使用类型" prop="name">
        <el-radio-group v-model="form.useScope" @change="getType">
          <el-radio :label="1" :disabled="disabledId&&!perMission">全场通用</el-radio>
          <el-radio :label="2" :disabled="disabledId&&!perMission">指定分类</el-radio>
          <el-radio :label="3" :disabled="disabledId&&!perMission">指定商品</el-radio>
          <el-radio :label="4" :disabled="disabledId&&!perMission">线下使用</el-radio>
          <el-radio :label="5" :disabled="disabledId&&!perMission">商家服务</el-radio>
          <el-radio :label="6" :disabled="disabledId&&!perMission">智能推介</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="核销商家" v-if="form.useScope === 4">
         <select-user :value="form.merchantIdList" @update:value="form.merchantIdList = $event">
         </select-user>
      </el-form-item>

      <el-form-item label="指定分类" v-if="form.useScope === 2">
        <el-select class="filter-item" multiple v-model="form.categoryIds" placeholder="请选择">
          <el-option
            v-for="item in productClassification"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.useScope === 3" label="指定商品">
          <select-goods :value="form.goodsIds" @update:value="form.goodsIds = $event">

          </select-goods>
      </el-form-item>
      <el-form-item v-if="form.useScope === 5" label="指定产品">
        <select-product :value="form.productIds" @update:value="form.productIds = $event">

        </select-product>
      </el-form-item>
    </el-form>
    <div class="footer" v-if="!editorialJudgment && !stateId">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getCreate('form')">确 定</el-button>
    </div>
    <div class="footer" v-if="editorialJudgment && !stateId">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getModify('form')">确 定</el-button>
    </div>
  </d2-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { getClassificationd } from '@/api/demo/classification/index'
import commodity from '../../../../components/commodity/shop.vue'
import {
  getAdde,
  getInfoD,
  getArrEdit,
  getSpuArr
} from '@/api/demo/discount/index'
import SelectUser from '@/components/users/selectUser.vue'
import SelectGoods from '@/components/commodity/selectGoods.vue'
import SelectProduct from '@/components/product/selectProduct.vue'
export default {
  components: {
    SelectGoods,
    SelectUser,
    commodity,
    SelectProduct
    // 商品选择组件
  },
  name: 'discountAdd',
  data () {
    return {
      radio: '1',
      tableKey: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        keyword: ''
      },
      form: {
        name: undefined, // 名称
        introduce: null, // 介绍
        reduceCost: null, // 减免金额
        leastCost: null, // 起用金额
        limitCount: null, // 限领数量
        startTime: null, // 开始时间
        endTime: null, // 结束时间
        stat: 1, // 状态
        type: 1, // 类型
        useScope: 1, // 使用范围
        categoryIds: [], // 产品分类
        goodsIds: [], // 商品分类
        merchantIds: [] // 核销商家
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入优惠券名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        introduce: [
          {
            required: true,
            message: '请输入优惠券介绍',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        reduceCost: [
          {
            required: true,
            message: '请输入减免金额',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        leastCost: [
          {
            required: true,
            message: '请输入起用金额',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        limitCount: [
          {
            required: true,
            message: '请输入限领数量',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ]
      },
      productClassification: [], // 产品分类
      classification: false, // 产品分类
      designatedGoods: false, // 指定商品
      multipleSelection: [], // 指定商品
      dlGoodsShow: false, // 选择商品
      dialogGoodsList: [], // 弹窗商品列表
      customized: [
        { index: 1, name: '全场赠券' },
        { index: 2, name: '会员赠券' },
        { index: 3, name: '购物赠券' },
        { index: 4, name: '注册赠券' },
        { index: 5, name: '后台发放' }
      ],
      total: null,
      listLoading: true, // 加载圈圈
      dataList: [],

      getId: null, // 页面接收参数
      editorialJudgment: false, // 判断新增或者编辑
      editorialJudgmedis: false, // 根据状态判断
      disabledId: false, // 判断状态

      perMission: false,
      stateId: 0,
      stateZ: false
    }
  },
  computed: {
    ...mapGetters(['elements'])
  },
  created () {
    let that = this
    getClassificationd({}).then(res => {
      that.productClassification = res
    })
    that.perMission = that.$route.query.perMission
    that.getId = that.$route.query.id
    that.stateId = that.$route.query.state
    if (that.stateId != null) {
      that.stateZ = true
    }
    if (this.getId != undefined) {
      that.editorialJudgment = true
      that.getListArr()
    } else if (this.getId == undefined) {
      that.editorialJudgment = false
    }
  },
  watch: {
    $route (to, from) {
      // this.getList();
    }
  },
  mounted () {},
  methods: {
    getListArr () {
      let that = this
      getInfoD(that.getId).then(res => {
        that.form = res
        if (res.stat > 0) {
          that.disabledId = true
        }
        if (res.stat == 0 || res.stat == 2) {
          that.editorialJudgmedis = false
        } else if (res.stat == 1) {
          that.editorialJudgmedis = true
        }
      })
    },
    // 类型
    selectCustomized (e) {
      this.form.type = e
      console.log('e', e)
    },
    // 开始时间
    dataSearch (e) {
      this.form.startTime = e
      console.log('e', this.form.startTime)
    },
    // 结束时间
    dataEnd (e) {
      this.form.endTime = e
      console.log('e', this.form.endTime)
    },
    // 选择状态
    getState (e) {
      this.form.stat = e
      console.log('状态', e, this.form.stat)
    },
    // 新增优惠券
    getCreate () {
      let that = this
      getAdde(this.form).then(res => {
        that.$notify({
          title: '成功',
          message: '新增成功',
          type: 'success',
          duration: 2000
        })
        that.$router.push('/demo/discount')
      })
    },
    // 编辑确定
    getModify () {
      let that = this
      if (this.$route.query.perMission) {
        getAdde(this.form).then(res => {
          that.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
            duration: 2000
          })
          that.$router.push('/demo/discount')
        })
      } else {
        this.$confirm('确定编辑？, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            getArrEdit(that.form, that.getId).then(res => {
              that.$notify({
                title: '成功',
                message: '编辑成功',
                type: 'success',
                duration: 2000
              })
              that.$router.push('/demo/discount')
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消编辑'
            })
          })
      }
    },
    // 取消
    cancel (formName) {
      this.$router.push('/demo/discount')
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getListArr()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getListArr()
    }
  }
}
</script>
<style scoped>
.footer {
  text-align: center;
  margin-top: 30px;
}
.el-dialog__footer {
  display: flex;
}
</style>
